import React, { useState } from "react";
import "./UserEditForm.css";
import Select from "react-select";

function UserEditForm({ user, onClose, onSave }) {
  const [formData, setFormData] = useState({ ...user });

  const allRoles = [
    { value: "Admin", label: "Admin" },
    { value: "Software Developer", label: "Software Developer" },
    { value: "Tester", label: "Tester" },
    { value: "Software Architect", label: "Software Architect" },
    { value: "Product Manager", label: "Product Manager" },
    { value: "Business Analyst", label: "Business Analyst" },
    { value: "Product Owner", label: "Product Owner" },
    { value: "UI/UX", label: "UI/UX" },
    { value: "DevOps Engineer", label: "DevOps Engineer" },
    { value: "Practitioner", label: "Practitioner" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <h3>Edit User</h3>
        <form onSubmit={handleSubmit}>
          <label>
            Username:
            <input
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Email:
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              type="email"
              required
            />
          </label>

          <label>Role:</label>
          <Select
            options={allRoles}
            value={allRoles.find((option) => option.value === formData.role)}
            onChange={(selectedOption) =>
              setFormData((prev) => ({ ...prev, role: selectedOption.value }))
            }
            isSearchable
            isClearable={false}
            placeholder="Select role"
          />

          <label>
            Status:
            <select
              name="status"
              value={formData.status || "active"}
              onChange={handleChange}
              required
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </label>

          <div className="modal-buttons">
            <button type="submit">Save</button>
            <button type="button" className="red-button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserEditForm;
